(function () {
  const API_BASE = "/apps/pg-wishlist";
  const FORM_SELECTOR = "[data-pg-back-in-stock]";

  function safeJsonParse(text, fallback) {
    try {
      return JSON.parse(text);
    } catch {
      return fallback;
    }
  }

  function getVariants(container) {
    const script = container.querySelector("[data-pg-bis-variants]");
    return script ? safeJsonParse(script.textContent || "[]", []) : [];
  }

  function findVariant(variants, id) {
    const wanted = String(id || "");
    return variants.find((variant) => String(variant.id) === wanted) || null;
  }

  function getScopedVariantInput(container) {
    const section = container.closest(".shopify-section") || document;
    return section.querySelector('form[action*="/cart/add"] [name="id"]');
  }

  function getSelectedVariantId(container, variants) {
    const urlVariant = new URLSearchParams(window.location.search).get("variant");
    if (findVariant(variants, urlVariant)) return urlVariant;

    const input = getScopedVariantInput(container);
    if (input && findVariant(variants, input.value)) return input.value;

    return container.dataset.selectedVariantId || container.dataset.initialVariantId;
  }

  function setMessage(container, text, state) {
    const message = container.querySelector("[data-pg-bis-message]");
    if (!message) return;

    message.textContent = text || "";
    if (state) {
      message.dataset.state = state;
    } else {
      delete message.dataset.state;
    }
  }

  function setBusy(form, isBusy) {
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;

    button.disabled = isBusy;
    if (isBusy) {
      button.setAttribute("aria-busy", "true");
    } else {
      button.removeAttribute("aria-busy");
    }
  }

  function updateVisibility(container, explicitVariantId) {
    const variants = container.pgBackInStockVariants || getVariants(container);
    container.pgBackInStockVariants = variants;

    const selectedId = explicitVariantId || getSelectedVariantId(container, variants);
    const variant = findVariant(variants, selectedId);

    if (variant) {
      container.dataset.selectedVariantId = String(variant.id);
      container.dataset.variantTitle = variant.title || "";
    }

    container.hidden = !variant || !!variant.available;
    if (container.hidden) {
      setMessage(container, "", "");
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  async function subscribe(container, email) {
    const variantId = container.dataset.selectedVariantId || container.dataset.initialVariantId || "";
    const params = new URLSearchParams({
      action: "bis_subscribe",
      product_id: container.dataset.productId || "",
      variant_id: variantId,
      product_handle: container.dataset.productHandle || "",
    });

    const payload = {
      email,
      product_id: container.dataset.productId || "",
      variant_id: variantId,
      product_handle: container.dataset.productHandle || "",
      product_title: container.dataset.productTitle || "",
      variant_title: container.dataset.variantTitle || "",
      product_url: container.dataset.productUrl || window.location.href,
    };

    const response = await fetch(`${API_BASE}?${params.toString()}`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const text = await response.text();
    const json = safeJsonParse(text, null);

    if (!response.ok || !json || !json.ok) {
      throw new Error(json && json.error ? json.error : "subscribe_failed");
    }

    return json;
  }

  function initContainer(container) {
    if (container.dataset.pgBisInit === "1") return;
    container.dataset.pgBisInit = "1";
    container.pgBackInStockVariants = getVariants(container);

    updateVisibility(container);

    const form = container.querySelector("[data-pg-bis-form]");
    const emailInput = form ? form.querySelector('input[type="email"]') : null;

    if (form && emailInput) {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const email = emailInput.value.trim();
        if (!isValidEmail(email)) {
          setMessage(container, "Kérlek, adj meg egy érvényes e-mail címet.", "error");
          return;
        }

        setBusy(form, true);
        setMessage(container, "Feliratkozás folyamatban...", "");

        try {
          const result = await subscribe(container, email);
          if (result.alreadySubscribed) {
            setMessage(container, "Már korábban feliratkoztál erre a termékre.", "success");
          } else {
            setMessage(container, "Sikeresen feliratkoztál a termékértesítőre.", "success");
            emailInput.value = "";
          }
        } catch {
          setMessage(
            container,
            "Hiba történt, kérlek próbáld meg újra később, vagy írj nekünk üzenetet.",
            "error"
          );
        } finally {
          setBusy(form, false);
        }
      });
    }

    document.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (
        target.matches('[name="id"]') ||
        target.closest("variant-selects") ||
        target.closest("variant-radios")
      ) {
        window.setTimeout(() => updateVisibility(container), 0);
      }
    });

    if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event?.data?.variant;
        if (!variant) return;

        const localVariant = findVariant(container.pgBackInStockVariants, variant.id);
        if (localVariant) {
          localVariant.available = !!variant.available;
          updateVisibility(container, variant.id);
        }
      });
    }
  }

  function boot(root) {
    (root || document).querySelectorAll(FORM_SELECTOR).forEach(initContainer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    boot(event.target);
  });
})();
